module.exports = __webpack_public_path__ + "media/images/companyPage/speed-0d3352ccc3482fb89782ad57c2bf5140.svg";